import "./App.css";
import "./styles/components.css";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Quote from "./pages/Quote";
import CompletedPage from "./pages/CompletedPage";
import Admin from "./pages/Admin";
import RedirectionPage from "./pages/RedirectionPage";
import { Result } from "antd";

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            new URLSearchParams(location.search).get("application_id") ? (
              <RedirectionPage />
            ) : (
              <Result status="500" title="Service temporarily unavailable!!" />
            )
          }
        />

        <Route
          path="*"
          element={
            <div
              style={{
                minHeight: "95dvh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "100dvw",
              }}
            >
              <Result
                status="404"
                title={<h1>404</h1>}
                subTitle={
                  <p style={{ fontSize: "1.25rem", fontWeight: "600" }}>
                    Oops! The page you requested was not found.
                  </p>
                }
              />
            </div>
          }
        />

        {/* <Route path="/" element={<Quote />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/quote/complete" element={<CompletedPage />} /> */}
      </Routes>
    </div>
  );
}

export default App;

const StartPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        flexDirection: "column",
        gap: "2rem",
      }}
      className="flex_center"
    >
      <button
        className="primary_btn"
        onClick={() => {
          navigate("/quote");
        }}
      >
        Apply to be a Brokers{" "}
      </button>
      <p>OR</p>
      <button
        className="secondary_btn"
        onClick={() => {
          // navigate("/trailer");
        }}
      >
        Broker Login{" "}
      </button>
    </div>
  );
};
